/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST_WITH_PAGINATION(state, data) {
    state.list = data.items || [];
    state.pagination = data.pagination || {};
  },
  SET_LIST(state, data) {
    state.list = data || [];
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
  SET_DETAIL(state, student) {
    state.selecting = student;
  },
};
